export { default } from './RevampDetailTrack';
